import React from 'react';
import "../PC.css";
const Activities = () => {
  return (
    <div className="ABOUTmainContainer">
    <div className="allRightContent">
      <div className="allRightContentHeading">Placement Cell Activities</div>

      <div className="allRightContentProfile">
        {/* Profile information */}
        <center></center>
        <br />
        {/* Profile description */}
        <p>❖ Co-ordinate with institutes for the registration of students.</p>
      <p>❖ Develop contacts with recruiters and convince them to hire students.</p>
      <p>❖ Regularly update the Company database and maintain necessary communications with the company during recruitment drives.</p>
      <p>❖ Identify and recruit genuine placement agents to facilitate major recruitment drives on Campus.</p>
      <p>❖ Arrange various placement-related activities in the form of camps and walk-ins.</p>
      </div>
    </div>
  </div>
  );
};

export default Activities;
